import {Component, Inject, Input, Output, OnInit, EventEmitter} from 'ng-metadata/core';
import {PreFiltersService} from './preFilters.service';
import {SearchFieldsService} from '../search.fields.service';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {getTabToTiles} from '../../appConfig/appConfigForward';
import {getSearchConfiguration, getBackendSystem} from '../../appConfig/appConfigForward';
import {getTabs} from '../../appConfig/appConfigForward';
import {SearchService} from '../search.service';

const get = require('lodash/get');

@Component({
    selector: 'prm-pre-filters',
    templateUrl: 'components/search/preFilters/pre-filters.html',
})

export class PrmPreFilters implements OnInit {

    @Input() selectedTab: string;
    @Input() public preFilters: Object;
    @Output() public searchEvent: EventEmitter = new EventEmitter();

    private _filters;
    private searchConfig = getSearchConfiguration();
    private searchTabs = getTabs();
    private selectedSearchTab: string;

    private _mediaType;

    private tabChanged: boolean;

    private dependencies = {
        operator: (value) => {
            if (value === 'begins_with') {
                this.filters.targetField.backupOptions = this.filters.targetField.options;
                this.filters.targetField.options = ['title'];
                this.filters.targetField.selection = 'title';
                this.preFilters.targetField = 'title';
            } else if (this.filters.targetField.backupOptions) {
                this.filters.targetField.options = this.filters.targetField.backupOptions;
                this.addToOptionsInNotExists('targetField', 'title', false);
            }
        }

    }

    constructor(private preFiltersService: PreFiltersService,
                private searchService: SearchService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('searchBoxIcons') private searchBoxIcons: Object[],
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private searchFieldsService: SearchFieldsService,
                private configurationUtil: ConfigurationUtil) {

    }

    ngOnInit() {
        this.updatePreFiltersData();
        this.init();
        this.$scope.$watch(() => this.selectedTab, (newVal, oldVal) => {
            if (oldVal != newVal) {
                this.updatePreFiltersData();
                this.tabChanged = true;
            }
        });

        this.$scope.$watch(() => this.searchFieldsService.advancedSearch, (newVal, oldVal) => {

            if (oldVal != newVal) {
                this.updateFieldsFromUrl();
            }
        });
    }

    get filters() {
        return this._filters;
    }

    set filters(filters) {
        this._filters = filters;
    }

    public onChanged(curType, value) {
        if (this.filters[curType].replaceValue) {
            value = this.filters[curType].replaceValue(value);
        }
        this.changeOptionsByRelations(curType, value);
        this.preFilters[curType] = value;
    }

    public isActive(filter) {
        return filter.selection && filter.selection !== filter.defaultValue;
    }

    public search() {
        this.searchEvent.emit();
    }

    public isPreFiltersAlert() {
        let defaultForMediaType = (getBackendSystem() === 'suprima' ? 'any' : 'all_items')

        let mediaType = this.getValueExceptFor(this.filters.mediaType.selection, defaultForMediaType);
        let operator = this.getValueExceptFor(this.filters.operator.selection, 'contains');
        let targetField = this.getValueExceptFor(this.filters.targetField.selection, 'any');
        if (!mediaType && !operator && !targetField) {
            return false;
        }

        /* check if main search field is in focus */
        if (document.activeElement.id === 'searchBar') {
            return true;
        }

        if (this.tabChanged) {
            this.tabChanged = false;
            return true;
        }
    }

    public getPreFiltersAlert() {
        let defaultForMediaType = (getBackendSystem() === 'suprima' ? 'any' : 'all_items')

        let mediaType = this.getValueExceptFor(this.filters.mediaType.selection, defaultForMediaType);
        let operator = this.getValueExceptFor(this.filters.operator.selection, 'contains');
        let targetField = this.getValueExceptFor(this.filters.targetField.selection, 'any');
        let placeHolders = {
            idx_0: mediaType,
            idx_1: operator,
            idx_2: targetField
        };

        return this.$translate.instant('nui.aria.alertPreFilters', placeHolders);
    }

    /* exceptions
     * When select the operator as begins with the targetField can contains only Author / Creator
     */
    private changeOptionsByRelations(curType, value) {
        if (this.dependencies[curType]) {
            this.dependencies[curType](value);
        }

    }

    private init() {
        this.updateFieldsFromUrl();
        angular.forEach(this.preFilters, (value, key) => {
            this.changeOptionsByRelations(key, value);
        });
    }

    private getValueExceptFor(value, except) {
        if (value === except) {
            return;
        }
        return value;
    }

    private updateFieldsFromUrl() {
        let query = this.$stateParams['query'];
        let pFilter = this.$stateParams['pfilter'];
        if (query) {
            if (angular.isArray(query)) {
                query = query[0];
            }

            if (query.split(',').length >= 3) {
                let operator = query.split(',')[1];
                this.addToOptionsInNotExists('operator', operator, true);
                let targetField = query.split(',')[0];
                this.addToOptionsInNotExists('targetField', targetField, true);
            }
        }

        if (pFilter) {
            if (!angular.isArray(pFilter)) {
                pFilter = [pFilter];
            }
            let pfilterName = (getBackendSystem() === 'suprima' ? 'rtype' : 'pfilter');
            pFilter = pFilter.filter((cur) => {
                return cur.split(',')[0] === pfilterName;
            });
            if (pFilter && pFilter[0] && pFilter[0].split(',').length >= 3) {
                let mediaType = pFilter[0].split(',')[2];
                this.addToOptionsInNotExists('mediaType', mediaType, true);
            }
        }

        this.createOptionsTranslationMap(this._filters);

    }

    private addToOptionsInNotExists(curType, value, selectIt) {
        if (!this.filters[curType].options) {
            return;
        }
        let isExists = this.filters[curType].options.filter((x) => {
            return x === value
        });
        if (isExists.length === 0) {
            this.filters[curType].options.push(value);
        }

        if (selectIt) {
            this.filters[curType].selection = value;
            this.preFilters[curType] = value;
        }


    }

    private updatePreFiltersData() {
        /* TODO - if there are no Tabs? */
        let tabToTile = this.configurationUtil.getTile('SearchTileInterface-Simple', getTabToTiles(this.selectedTab));
        let qtvInstance = this.searchConfig[tabToTile].qtvinstance;

        let mediaType = this.preFiltersService.getPreFilterByType(qtvInstance, '.MediaType', 'mediaType');
        let operators = this.preFiltersService.getPreFilterByType(qtvInstance, '.simple.searchBox', 'precisionOperator');
        let targetFields = this.preFiltersService.getPreFilterByType(qtvInstance, '.simple.searchBox', 'scope');

        if (getBackendSystem() === 'suprima') {
            if (this.preFiltersService.isRTypePreFilterEnable(this.selectedTab)) {
                mediaType = this.preFiltersService.getPreFilterByType(qtvInstance, '.mediaType.', 'mediaType');
            }
            if (this.preFiltersService.isIndexedPreFilterEnable(this.selectedTab)) {
                targetFields = this.preFiltersService.getPreFilterByType(qtvInstance, '.searchbox_complex.', 'scope');
                operators = this.preFiltersService.getPreFilterByType(qtvInstance, '.searchbox_complex.', 'precisionOperator');
            }
        }

        if (mediaType && mediaType.length > 0) mediaType = mediaType[0];
        if (operators && operators.length > 0) operators = operators[0];
        if (targetFields && targetFields.length > 0) targetFields = targetFields[0];

        let defaultForMediaType = (getBackendSystem() === 'suprima' ? 'any' : 'all_items')

        this._filters =
            {
                mediaType: {
                    options: mediaType.options,
                    optionsTranslationMap: {},
                    translatePrefix: 'search-simple.mediaType.option.',
                    selection: get(mediaType, 'selection'),
                    display: true,
                    defaultValue: defaultForMediaType,
                    replaceValue: (value) => {
                        if (value === defaultForMediaType) return '';
                        return value;
                    }
                },
                operator: {
                    options: get(operators, 'options'),
                    optionsTranslationMap: {},
                    translatePrefix: 'search-simple.precisionOperator.option.',
                    selection: get(operators, 'selection'),
                    defaultValue: 'contains'
                },
                targetField: {
                    options: get(targetFields, 'options'),
                    optionsTranslationMap: {},
                    translatePrefix: 'search-simple.scope.option.',
                    selection: get(targetFields, 'selection'),
                    display: true,
                    defaultValue: 'any'
                }
            };

        this.createOptionsTranslationMap(this._filters);

        this.filters.operator.display = !!this.filters.operator.options;

        this.preFilters.mediaType = this.getValueExceptFor(this.filters.mediaType.selection, defaultForMediaType);
        this.preFilters.operator = this.filters.operator.selection || 'contains';
        this.preFilters.targetField = this.getValueExceptFor(this.filters.targetField.selection, 'any');
    }

    public getLabel(translatePrefix, option) {
        return this.$translate.instant(translatePrefix + option);
    }

    public getTranslateOptionLabel(filter, option) {
        return filter.optionsTranslationMap[option];
    }

    private createOptionsTranslationMap(filters) {
        Object.keys(filters).forEach((key) => {
            if (filters[key].options) {
                filters[key].options.forEach((option) => {
                    this.$translate(filters[key].translatePrefix + option).then((translation) => {
                        filters[key].optionsTranslationMap[option] = translation;
                    });
                });
            }
        });
    }

    public preFilterHeader() {
        return this.$translate.instant('nui.search.preFilters');
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/preFilters/preFilters.directive.ts